import { ColumnDescription } from "react-bootstrap-table-next";
import { IListaModeloRenegociacaoGrupo } from "../../../Interfaces/Cobranca/ModeloRenegociacaoGrupo/IModeloRenegociacaoGrupo";
import Table from "../../../Components/Table";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import {
    DeletarModeloRenegociacaoGrupoController,
    InserirModeloRenegociacaoGrupoController,
    ListarModeloRenegociacaoController,
    ListarModeloRenegociacaoGrupoController,
} from "../../../Controllers/Cobranca/ModeloRenegociacaoGrupo";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave, faTrash } from "@fortawesome/free-solid-svg-icons";
import OrSpinner from "../../../Components/Utils/OrSpinner";
import UnForm from "../../../Components/Form";
import { ListarGruposController } from "../../../Controllers/Geral/Grupos/GruposController";
import { ListarUsuariosController } from "../../../Controllers/Geral/GestaoUsuarios/UsuariosController";
import useAsyncCallback from "../../../hooks/useAsyncCallback";
import { useState } from "react";

export default function ModeloRenegociacaoGrupo() {
    const {
        value: lstModeloRenegociacaoGrupo,
        loading: lstModeloRenegociacaoGrupoLoading,
        execute: ListarModeloRenegociacaoGrupo,
    } = useAsyncEffect(() => ListarModeloRenegociacaoGrupoController(), []);

    const {
        execute: InserirModeloRenegociacaoGrupo,
        loading: inserirModeloRenegociacaoGrupoLoading,
    } = useAsyncCallback(InserirModeloRenegociacaoGrupoController);

    const { value: lstModeloRenegociacao } = useAsyncEffect(
        ListarModeloRenegociacaoController
    );

    const [dsModeloRenegociacao, setDsModeloRenegociacao] = useState("");

    function handleSalvarModeloRenegociacao(
        formData: IListaModeloRenegociacaoGrupo
    ) {
        InserirModeloRenegociacaoGrupo({
            ...formData,
            ID_GRUPO: Number(formData.ID_GRUPO),
            ID_MODELO_RENEGOCIACAO: Number(formData.ID_MODELO_RENEGOCIACAO),
            DS_MODELO_RENEGOCIACAO: dsModeloRenegociacao,
            ID_USUARIO: Number(formData.ID_USUARIO),
        }).then(() => {
            ListarModeloRenegociacaoGrupo();
        });
    }

    const handleModeloRenegociacaoChange = (
        e: React.ChangeEvent<HTMLSelectElement>
    ) => {
        const selectedOptionIndex = e.target.selectedIndex;
        if (selectedOptionIndex >= 0) {
            const selectedDescricaoMven =
                e.target.options[selectedOptionIndex].id;

            setDsModeloRenegociacao(selectedDescricaoMven);
        }
    };

    const tableviewColumns: Array<
        ColumnDescription<IListaModeloRenegociacaoGrupo>
    > = [
        {
            dataField: "DS_GRUPO",
            text: "Grupo",
        },
        {
            dataField: "DS_USUARIO",
            text: "Usuário",
        },
        {
            dataField: "DS_MODELO_RENEGOCIACAO",
            text: "Modelo Renegociação",
        },
        {
            dataField: "Excluir",
            text: "",
            formatter: (_, row: IListaModeloRenegociacaoGrupo) => (
                <button
                    className="btn  btn-sm btn-outline-danger font-weight-bold"
                    onClick={() => {
                        Swal.fire({
                            title: "Deseja apagar essa Renegociação?",
                            icon: "info",
                            buttonsStyling: false,
                            confirmButtonText:
                                "<i class='la la-check'></i> Sim!",
                            showCancelButton: true,
                            cancelButtonText:
                                "<i class='la la-thumbs-down'></i> Não",
                            customClass: {
                                confirmButton: "btn btn-outline-success",
                                cancelButton: "btn btn-default",
                            },
                        }).then((result) => {
                            if (result.isConfirmed) {
                                DeletarModeloRenegociacaoGrupoController(
                                    row.ID_MODELO_RENEGOCIACAO_GRUPO
                                ).then(() => {
                                    ListarModeloRenegociacaoGrupo();
                                });
                            }
                        });
                    }}
                >
                    <FontAwesomeIcon icon={faTrash} size="lg" />
                </button>
            ),
        },
    ];

    return (
        <div className="card card-custom">
            <div className="col-12">
                <UnForm
                    className="row"
                    handleSubmit={handleSalvarModeloRenegociacao}
                >
                    <div className="col-md-3 py-3">
                        <label>Grupo</label>
                        <UnForm.LazySelect
                            name="ID_GRUPO"
                            className="form-control placeholder-dark-75"
                            controller={ListarGruposController}
                            getDS={(ds) => ds.DS_GRUPO}
                            getKeyValue={(key) => key.ID_GRUPO}
                            required
                        >
                            <option></option>
                        </UnForm.LazySelect>
                    </div>
                    <div className="col-md-3 py-3">
                        <label>Usuário</label>

                        <UnForm.LazySelect
                            name="ID_USUARIO"
                            className="form-control placeholder-dark-75"
                            controller={ListarUsuariosController}
                            getDS={(ds) => ds.DS_NOME}
                            getKeyValue={(key) => key.ID_USUARIO}
                        >
                            <option></option>
                        </UnForm.LazySelect>
                    </div>
                    <div className="col-md-3 py-3">
                        <label>Modelo de Renegociação</label>

                        <UnForm.Select
                            name="ID_MODELO_RENEGOCIACAO"
                            className="form-control placeholder-dark-75"
                            // controller={ListarModeloRenegociacaoController}
                            // getDS={(ds) => ds.descricao_mven}
                            // getKeyValue={(key) => key.num_mven}
                            onChange={handleModeloRenegociacaoChange}
                            required
                        >
                            <option></option>
                            {lstModeloRenegociacao?.map((x) => (
                                <option
                                    value={x.num_mven}
                                    id={x.descricao_mven}
                                >
                                    {x.descricao_mven}
                                </option>
                            ))}
                        </UnForm.Select>
                    </div>
                    <div className="col-md-3 pt-7 d-flex align-items-center justify-content-center">
                        <UnForm.SubmitButton
                            color="primary"
                            icon={faSave}
                            className="btn btn-primary w-50"
                            loading={inserirModeloRenegociacaoGrupoLoading}
                            loadingSize="sm"
                        >
                            Salvar
                        </UnForm.SubmitButton>
                    </div>
                </UnForm>
            </div>

            <OrSpinner
                loading={lstModeloRenegociacaoGrupoLoading}
                spinner="capys"
            >
                <Table
                    data={lstModeloRenegociacaoGrupo ?? []}
                    columns={tableviewColumns}
                    tableView={{
                        columns: tableviewColumns,
                        cancelYScroll: true,
                        defaultStyle: true,
                        striped: true,
                    }}
                    keyField="ID_MODELO_RENEGOCIACAO_GRUPO"
                    noDataIndication={() => (
                        <div className="text-center text-muted">
                            Nenhum modelo de renegociação
                        </div>
                    )}
                    rowStyle={{ height: 80 }}
                    bordered={false}
                    defaultStyle={{ align: "center" }}
                    striped={false}
                    noSearch
                />
            </OrSpinner>
        </div>
    );
}
